import type {NgModule} from '@angular/core';

export const imports: Exclude<NgModule['imports'], undefined> = [
];
